<template>
  <section class="container">
    <pre v-html="noviceContent" />

    <!-- <div class="contact">
      <div class="contact__block">
        <div class="contact__map">
          <iframe
            class="w-100"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.4279294022203!2d121.52117327569866!3d25.053481137506257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a968e9759781%3A0x958c3a74e08ab282!2zMTA0OTHlj7DljJfluILkuK3lsbHljYDljZfkuqzmnbHot6_kuIDmrrUxM-W3tzXomZ8y!5e0!3m2!1szh-TW!2stw!4v1723044502794!5m2!1szh-TW!2stw"
            width="600"
            height="450"
            frameborder="0"
            style="border:0;"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
        </div>
        <div class="contact__info">
          <div>
            <img src="@/assets/images/logo.png" alt="" />
            <p>{{ $t('contact.label.phone') }}：{{ novicesContactPhone }}</p>
            <p>{{ $t('contact.label.address') }}：{{ novicesContactAddress }}</p>
            <p>{{ $t('contact.label.businessHours') }}：{{ novicesContactOpenTime }}</p>
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
// import { GetNovicesContact } from '@/api/Novices';
import { GetNovicesByMode } from '@/api/Novices';

export default {
  data() {
    return {
      // novicesContactAddress: '',
      // novicesContactPhone: '',
      // novicesContactOpenTime: '',

      noviceContent: '',

      pageType: 7,
    };
  },
  created() {
    this.GetData();
  },
  methods: {
    // GetData() {
    //   window.document.title = '成均學院-聯絡我們';
    //   GetNovicesContact().then((response) => {
    //     if (response.data.statusCode === 0) {
    //       const { data } = response.data;
    //       this.novicesContactAddress = data?.novicesContactAddress;
    //       this.novicesContactPhone = data?.novicesContactPhone;
    //       this.novicesContactOpenTime = data?.novicesContactOpenTime;
    //     }
    //   });
    // },

    GetData() {
      window.document.title = `${this.$t('route.title.sitePrefix')}-${this.$t('contact.pageTitle')}`;
      GetNovicesByMode(this.pageType).then((response) => {
        if (response.data.statusCode === 0) {
          this.noviceContent = response.data.data.noviceContent;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact {
  &__block {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  &__map {
    max-width: 50%;
    width: 700px;

    @media (max-width: 991px) {
      max-width: 100%;
      width: 100%;
      order: 1;
    }

    iframe {
      width: 100%;
    }
  }

  &__info {
    max-width: 50%;
    margin-left: 50px;
    color: #555;

    @media (max-width: 991px) {
      max-width: 100%;
      width: 100%;
      margin: 0 0 30px;

      order: 0;
    }

    img {
      width: 240px;
      margin-bottom: 20px;
    }
  }
}
</style>
